import { Component, OnInit, Inject, Input, OnChanges } from '@angular/core';
import { DOCUMENT } from '@angular/platform-browser';

import { PageScrollConfig, PageScrollService, PageScrollInstance } from 'ng2-page-scroll';

import { ActionUpdaterService, ApiError } from '../../services/action-updater.service';
import { Observable } from 'rxjs';

@Component({
    selector: 'gaweb-error-summary',
    template: `
          <div *ngFor="let alert of alerts"
              class="col-xs-12 col-md-12 success-alert">
              <div role="alert" class="alert alert-danger alert--wrap">
                  <i class="fa fa-exclamation-circle"></i>&nbsp;<strong>{{ alert.summary }}</strong>
                  <ul>
                    <li *ngFor="let detail of alert.details">
                    <span *ngIf="!!detail.Value">{{detail.Value}}</span>
                    <span *ngIf="!!!detail.Value">{{detail}}</span>
                    </li>
                  </ul>
              </div>
          </div>
  `,
    styles: [`
        .alert--wrap {
            word-wrap: break-word;
        }
    `]
})
export class ErrorSummaryComponent implements OnInit, OnChanges {
    @Input()
    alerts: Array<ApiError>;
    @Input()
    worksWithEvents = true;
    @Input()
    scrollToHead = false;
    pageScrollInstance: PageScrollInstance;

    constructor(private actionUpdaterService: ActionUpdaterService,
        private pageScrollService: PageScrollService,
        @Inject(DOCUMENT) private document: any) {
        this.pageScrollInstance = PageScrollInstance.simpleInstance(this.document, '#head');
    }

    ngOnInit() {
        if (this.worksWithEvents) {
            this.actionUpdaterService.errors.subscribe(
                (apiError: ApiError[]) => {
                    apiError = apiError || [];
                    const errors = apiError.filter(el => !!el);
                    if (!!errors.length) {
                        this.alerts = errors;
                        this.goToErrorSection();
                    }
                });

            this.actionUpdaterService.clear$.subscribe(
                clear => {
                    this.alerts = [];
                });
        }
    }


    ngOnChanges(changes: any) {
       if (!this.worksWithEvents && !!this.alerts && this.alerts.length > 0 && this.scrollToHead) {
           this.goToErrorSection();
       }
    }

    public goToErrorSection = (): void => {
        this.pageScrollService.start(this.pageScrollInstance);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/error-summary/error-summary.component.ts